import React from 'react';

const Maine = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Maine Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>Lead Paint Disclosure: Required for homes built before 1978.</li>
        <li>
          Private Sewage Disposal System Disclosure: Mandatory for applicable
          properties.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Maine-Property-Disclosure-Residential.pdf',
                '_blank'
              );
            }}
          >
            Seller's Property Disclosure Statement{' '}
          </span>{' '}
          – Sellers are required to disclose information regarding the
          property's water supply, insulation, heating, waste disposal, and any
          defects.
        </li>
      </ol>
    </div>
  );
};

export default Maine;
